import Scaling from '../../Scaling.js';
import BaseWeapon from '../base.js';

const HarbingerOfDawn = (props) => {
  
  return BaseWeapon({
    ...props,
    type: 'sword',
    name: 'Harbinger of Dawn',
    lvl1Atk: 39,
    lvl1Sub: 0.102,
    subType: 'critDmg',
    PersistentResolve(result, context) {
      /**
       * effect: 'When HP is above 90%, increases CRIT Rate by [14%].'
       */
      if(this.IsSelf(result)) {
      }
      return result;
    }
  });
};

export default HarbingerOfDawn;